export default {
  totalMarketValue: '總市場價值', walletActions: '錢包操作', claim: '領取', swap: '兌換', send: '發送', receive: '接收',
  onChainAssets: '鏈上資產', updateAssets: '更新資產', selectAssetAccount: '選擇資產帳戶', currentViewing: '目前查看：{{source}}',
  inGameAssets: '遊戲內資產', updateBalance: '更新餘額', priceLoading: '價格更新中…', priceUnavailable: '價格暫不可用',
  priceUpdatedAt: '價格更新於 {{time}}', priceNotAvailable: '未提供市場價格',
} as const;

